"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatBannerResponse = exports.bannerPreMessageDisplay = void 0;
const types_1 = require("./types");
exports.bannerPreMessageDisplay = {
    [types_1.BannerType.INFO]: `Heads-up!`,
    [types_1.BannerType.SERVICE_UNAVAILABLE]: `Planned Downtime:`,
    [types_1.BannerType.ONGOING_ISSUE]: `We're on it!`,
};
const formatBannerResponse = (banner) => {
    return {
        bannerId: banner.banner_id,
        type: banner.type,
        startDateTime: banner.start_date_time,
        endDateTime: banner.end_date_time,
        message: banner.message,
        status: banner.status,
        product: banner.product,
        meta: {
            createdAt: banner._meta.created_at,
            createdBy: banner._meta.created_by,
            updatedAt: banner._meta.updated_at,
            updatedBy: banner._meta.updated_by,
        },
    };
};
exports.formatBannerResponse = formatBannerResponse;
//# sourceMappingURL=utils.js.map